module.exports = __webpack_public_path__ + "img/napoli.a17a5136.png";